export default __webpack_public_path__ + "static/media/world-atlas-1-lqMAX.94b342ed.jpg";